export const ADD_TRADE_IN = 'ADD_TRADE_IN';
export const DELETE_TRADE_IN = 'DELETE_TRADE_IN';
export const UNDO_DELETED_TRADE_IN = 'UNDO_DELETED_TRADE_IN';
export const TOGGLE_TRADE_IN_ACCORDION_STATE = 'TOGGLE_TRADE_IN_ACCORDION_STATE';

export const TRADE_INS_UPDATE_DOORS = 'TRADE_INS_UPDATE_DOORS';
export const TRADE_INS_UPDATE_LIENHOLDER_FULL = 'TRADE_INS_UPDATE_LIENHOLDER_FULL';
export const TRADE_INS_UPDATE_DRIVE_LINE = 'TRADE_INS_UPDATE_DRIVE_LINE';
export const TRADE_INS_DETAILS_MANUAL_ENTRY_SAVE = 'TRADE_INS_DETAILS_MANUAL_ENTRY_SAVE';
export const INCLUDE_TRADE_INS_CHANGED = 'INCLUDE_TRADE_INS_CHANGED';
export const TRADE_INS_ALLOWANCE_CHANGED = 'TRADE_INS_ALLOWANCE_CHANGED';
export const TRADE_INS_PAYOFF_CHANGED = 'TRADE_INS_PAYOFF_CHANGED';
export const TRADE_INS_ACV_CHANGED = 'TRADE_INS_ACV_CHANGED';
export const TRADE_INS_UPDATE_IS_BUYER_REGISTERED_OWNER = 'TRADE_INS_UPDATE_IS_BUYER_REGISTERED_OWNER';
export const TRADE_INS_UPDATE_IS_SELLING_VEHICLE_REGISTERED_IN_SAME_STATE =
    'TRADE_INS_UPDATE_IS_SELLING_VEHICLE_REGISTERED_IN_SAME_STATE';
export const TRADE_INS_UPDATE_ODOMETER = 'TRADE_INS_UPDATE_ODOMETER';
export const TRADE_INS_UPDATE_STOCK_NUMBER = 'TRADE_INS_UPDATE_STOCK_NUMBER';
export const TRADE_INS_UPDATE_YEAR = 'TRADE_INS_UPDATE_YEAR';
export const TRADE_INS_UPDATE_MAKE = 'TRADE_INS_UPDATE_MAKE';
export const TRADE_INS_UPDATE_MAKE_ID = 'TRADE_INS_UPDATE_MAKE_ID';
export const TRADE_INS_UPDATE_MODEL = 'TRADE_INS_UPDATE_MODEL';
export const TRADE_INS_UPDATE_MODEL_ID = 'TRADE_INS_UPDATE_MODEL_ID';
export const TRADE_INS_UPDATE_TRIM = 'TRADE_INS_UPDATE_TRIM';
export const TRADE_INS_UPDATE_EXTERIOR_COLOR = 'TRADE_INS_UPDATE_EXTERIOR_COLOR';
export const TRADE_INS_UPDATE_CONDITION = 'TRADE_INS_UPDATE_CONDITION';
export const TRADE_INS_UPDATE_ENGINE = 'TRADE_INS_UPDATE_ENGINE';
export const TRADE_INS_UPDATE_TRANSMISSION = 'TRADE_INS_UPDATE_TRANSMISSION';
export const TRADE_INS_UPDATE_BODY_STYLE = 'TRADE_INS_UPDATE_BODY_STYLE';
export const TRADE_INS_UPDATE_INTERIOR_COLOR = 'TRADE_INS_UPDATE_INTERIOR_COLOR';
export const TRADE_INS_UPDATE_OWNERSHIP_TYPE = 'TRADE_INS_UPDATE_OWNERSHIP_TYPE';
export const TRADE_INS_UPDATE_VIN = 'TRADE_INS_UPDATE_VIN';
export const TRADE_INS_VIN_REQUEST = 'TRADE_INS_VIN_REQUEST';
export const TRADE_INS_VIN_SUCCESS = 'TRADE_INS_VIN_SUCCESS';
export const TRADE_INS_VIN_FAILURE = 'TRADE_INS_VIN_FAILURE';
export const TRADE_INS_MULTIPLE_VIN_SELECTED = 'TRADE_INS_MULTIPLE_VIN_SELECTED';
export const TRADE_INS_COMPONENT_UPDATE_VEHICLE = 'TRADE_INS_COMPONENT_UPDATE_VEHICLE';
export const TRADE_INS_MAKES_REQUEST = 'TRADE_INS_MAKES_REQUEST';
export const TRADE_INS_MAKES_SUCCESS = 'TRADE_INS_MAKES_SUCCESS';
export const TRADE_INS_MAKES_FAILURE = 'TRADE_INS_MAKES_FAILURE';
export const TRADE_INS_VEHICLES_REQUEST = 'TRADE_INS_VEHICLES_REQUEST';
export const TRADE_INS_VEHICLES_SUCCESS = 'TRADE_INS_VEHICLES_SUCCESS';
export const TRADE_INS_VEHICLES_FAILURE = 'TRADE_INS_VEHICLES_FAILURE';
export const TRADE_INS_MODELS_REQUEST = 'TRADE_INS_MODELS_REQUEST';
export const TRADE_INS_MODELS_SUCCESS = 'TRADE_INS_MODELS_SUCCESS';
export const TRADE_INS_MODELS_FAILURE = 'TRADE_INS_MODELS_FAILURE';
export const TRADE_INS_TRIMS_REQUEST = 'TRADE_INS_TRIMS_REQUEST';
export const TRADE_INS_TRIMS_SUCCESS = 'TRADE_INS_TRIMS_SUCCESS';
export const TRADE_INS_TRIMS_FAILURE = 'TRADE_INS_TRIMS_FAILURE';
